import React from "react";
import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useKateChatStore } from "src/ai/aiChatStore";

export const SessionsSidebar: React.FC = () => {
  const sessions = useKateChatStore((s) => s.sessions);
  const activeId = useKateChatStore((s) => s.activeSessionId);
  const createSession = useKateChatStore((s) => s.createSession);
  const switchSession = useKateChatStore((s) => s.switchSession);
  const deleteSession = useKateChatStore((s) => s.deleteSession);

  return (
    <Box
      sx={{
        width: 200,
        borderRight: "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "rgba(0,0,0,0.02)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 1,
          borderBottom: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          Sessions
        </Typography>
        <Tooltip title="New chat">
          <IconButton size="small" onClick={() => createSession()}>
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <List dense sx={{ flex: 1, overflowY: "auto", p: 0 }}>
        {sessions.length === 0 && (
          <Box sx={{ p: 1.5, color: "text.secondary" }}>
            <Typography variant="caption">No sessions yet.</Typography>
          </Box>
        )}
        {sessions.map((session) => (
          <ListItemButton
            key={session.id}
            selected={session.id === activeId}
            onClick={() => switchSession(session.id)}
            sx={{
              pr: 0.5,
              "& .delete-btn": { opacity: 0 },
              "&:hover .delete-btn": { opacity: 1 },
            }}
          >
            <ListItemText
              primary={
                <Typography
                  variant="body2"
                  noWrap
                  sx={{ fontSize: "0.82rem" }}
                >
                  {session.title}
                </Typography>
              }
            />
            <IconButton
              className="delete-btn"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                deleteSession(session.id);
              }}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};
